<div class="columns">
  <div class="column right">
    <button *ngIf="canCreateProject" class="btn btn-dark" (click)="createProject()">Create Project</button>
    <button *ngIf="!canCreateProject" ngbTooltip="Subscription Needed" class="btn btn-dark disabled">Create Project</button>
    <div class="images">
      <iframe style="width:100%;height:100%" src="https://www.youtube.com/embed/AV3MjVXneD8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>

  <div class="column">
    <div>
      <documentation-atlassian
        [docAtlassianID]="3007610956"
      ></documentation-atlassian>
    </div>
  </div>
</div>